import type { ModuleDefinitionType } from '../../types/authenticateSmartcheckSessionDto'
import { ClientInputsType } from '../../types/clientInputs'
import { CarCostExtendedStep, CarCostStep } from './Components/carCostStep'
import { FamilyInformationStep } from './Components/familyInformationStep'
import { HomeInformationStep } from './Components/HomeInformationStep'
import { HouseholdSingleCohabitantQuestionnaire } from './Components/HouseholdSingleCohabitantQuestionnaire/HouseholdSingleCohabitantQuestionnaire'
import MbfStep from './Components/mbfStep'
import {
	PersonalInformationCprOnlyStep,
	PersonalInformationExtendedStep,
	PersonalInformationStep,
} from './Components/personalInformation/personalInformationStep'
import {
	ModuleDefinitionQuestionnaire,
	type QuestionnaireStep,
	type ModuleDefinitionQuestionnaireType,
} from './types/questionnaire.types'

export type QuestionnaireStepWithType = QuestionnaireStep & {
	type: ModuleDefinitionType
}

export const getNegativeValue = (value?: number | null): number => {
	return value != undefined ? -value : 0
}

export const getQuestionnaireStep = (
	type: ModuleDefinitionQuestionnaireType,
	loanType?: ClientInputsType,
) => {
	switch (type) {
		case ModuleDefinitionQuestionnaire.AssetQuestionnaire:
			return loanType === ClientInputsType.HomeLoan
				? HomeInformationStep
				: CarCostStep
		case ModuleDefinitionQuestionnaire.CarExtendedQuestionnaire:
			return loanType === ClientInputsType.HomeLoan
				? HomeInformationStep
				: CarCostExtendedStep
		case ModuleDefinitionQuestionnaire.HouseholdQuestionnaire:
			return FamilyInformationStep
		case ModuleDefinitionQuestionnaire.HouseholdSingleCohabitantQuestionnaire:
			return HouseholdSingleCohabitantQuestionnaire
		case ModuleDefinitionQuestionnaire.PersonalInformationQuestionnaire:
			return PersonalInformationStep
		case ModuleDefinitionQuestionnaire.PersonalInformationExtendedQuestionnaire:
			return PersonalInformationExtendedStep
		case ModuleDefinitionQuestionnaire.PersonalInformationCprOnlyQuestionnaire:
			return PersonalInformationCprOnlyStep
		case ModuleDefinitionQuestionnaire.MbfQuestionnaire:
			return MbfStep
	}
}

export const getSectionFromQuestionnaireType = (
	type: ModuleDefinitionType,
): ModuleDefinitionQuestionnaireType | undefined => {
	switch (type) {
		case ModuleDefinitionQuestionnaire.PersonalInformationQuestionnaire:
		case ModuleDefinitionQuestionnaire.PersonalInformationCprOnlyQuestionnaire:
		case ModuleDefinitionQuestionnaire.PersonalInformationExtendedQuestionnaire:
			return ModuleDefinitionQuestionnaire.PersonalInformationQuestionnaire
		case ModuleDefinitionQuestionnaire.HouseholdQuestionnaire:
			return ModuleDefinitionQuestionnaire.HouseholdQuestionnaire
		case ModuleDefinitionQuestionnaire.AssetQuestionnaire:
		case ModuleDefinitionQuestionnaire.CarExtendedQuestionnaire:
			return ModuleDefinitionQuestionnaire.AssetQuestionnaire
		default:
			return
	}
}

export const isLastStepInSection = (
	stepIndex: number,
	groupType: ModuleDefinitionQuestionnaireType | undefined,
	steps: QuestionnaireStepWithType[],
) => {
	const reversedLastIndexForSection = [...steps]
		.reverse()
		.findIndex(
			(step: QuestionnaireStepWithType) =>
				groupType === getSectionFromQuestionnaireType(step.type),
		)

	const lastIndexForSection = steps.length - reversedLastIndexForSection - 1

	return groupType != null && stepIndex === lastIndexForSection
}
